export function resolvePageKey(pathname: string): string | null {
  const path = pathname.replace(/^\/[a-z]{2}(\/|$)/, "/");

  if (path === "/" || path === "") return "home";
  if (path.startsWith("/analytics")) return "analytics";
  if (path.startsWith("/new")) return "new";

  return null;
}
